import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles/index';
import Button from '@material-ui/core/Button';
import CancelIcon from '@material-ui/icons/Cancel';
import {Typography} from '@material-ui/core/';
import Chip from '@material-ui/core/Chip';
import FaceIcon from '@material-ui/icons/Face';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
// import AddIcon from '@material-ui/icons/Add';
// import DomainIcon from '@material-ui/icons/Domain';
// import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';

const styles = theme => ({
    root: {
        padding: 0
    }
});

class ProfilPanel extends Component {

    // constructor(props) {
    //     super(props);
    //     this.state = {
    //         error: null,
    //         isLoaded: false
    //     };

    //     console.log(this.props);
    // }
    state = {
        error: null,
        isLoaded: false
    }

    handleLogoutButton = (event, data) => {
        // console.log(window.location.pathname.split('/').length);
        // console.log(this.props.location.pathname.split('/'));
        localStorage.setItem('jwt_token', '');
        localStorage.setItem('access_token', '');
        localStorage.setItem('user', '');
        localStorage.setItem('pengguna_id_ops', '');
        localStorage.setItem('aslinya_ops', '');

        window.location.href="/";
        // // window.location.reload();
        // if(window.location.pathname.split('/').length === 3){
        //     window.location.href="../"+localStorage.getItem('root_base');
        //     // window.location.reload(true);

        // }else{
        //     window.location.href=localStorage.getItem('root_base');
        //     // window.location.reload(true);

        // }

    }

    render()
    {
        const { classes } = this.props;

        // console.log(localStorage.getItem('user'));

        return (
                <div>
                    <h1 style={{fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif', fontStyle: 'normal', fontWeight: 800, lineHeight: 1, fontSize: 30}}>{JSON.parse(localStorage.getItem('user')).nama}</h1>
                    <br />
                    <Chip
                        icon={<FaceIcon />}
                        label={JSON.parse(localStorage.getItem('user')).email}
                        className={classes.chip}
                        color="primary"
                        style={{width: '100%', justifyContent: 'start', borderRadius: 0}}
                    />
                    <Card className={classes.card}>
                        <CardContent style={{padding: 10}}>
                            <Typography className={classes.title} color="textSecondary" gutterBottom>
                                
                            </Typography>
                            
                        </CardContent>
                        <CardActions>
                            {/* <Button size="large" variant="contained" color="secondary" className={classes.button} style={{width: '50%', background: '#00c039'}}>
                                <VerifiedUserIcon className={classes.extendedIcon} style={{color: 'white'}} />
                                <Typography style={{color: 'white', paddingLeft: '10px'}}>Profil</Typography>
                            </Button> */}
                            {localStorage.getItem('tipe_app') === "1" &&
                            <Button size="large" variant="contained" color="secondary" className={classes.button} style={{width: '100%', background: '#ff9e22'}} onClick={this.handleLogoutButton}>
                                <CancelIcon className={classes.extendedIcon} style={{color: 'white'}} />
                                <Typography style={{color: 'white', paddingLeft: '10px'}}>Keluar</Typography>
                            </Button>
                            }
                        </CardActions>
                    </Card>
                    <br />
                    {/* <Chip
                        icon={<DomainIcon />}
                        label="Sekolah"
                        className={classes.chip}
                        color="primary"
                        style={{width: '100%', justifyContent: 'start', borderRadius: 0}}
                    />
                    <Card className={classes.card} style={{minHeight: 10}}>
                        <Typography style={{padding: 10}}>Anda belum membuat sekolah</Typography>
                        <Button style={{width: '100%', background: '#1abc9c', color: 'white', borderRadius: 0}} onClick={this.buatSekolahButton}>
                            <AddIcon className={classes.extendedIcon} style={{color: 'white'}} />
                            <Typography style={{color: 'white', paddingLeft: '10px'}}>Buat Sekolah Sekarang</Typography>
                        </Button>
                    </Card> */}
                    {/* <div style={{height: 50, borderBottom: '1px solid #ccc', marginBottom: 10}}></div> */}
                    
                </div>
            )
    }
}

export default withStyles(styles, {withTheme: true})(ProfilPanel);


// WEBPACK FOOTER //
// ./src/main/quickPanel/ProfilPanel.js